import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { PrimeGlyph } from "./PrimeGlyph";

// PRIMENG `p-dropdown` IN THE PILLARS THEMES: ALWAYS 100% WIDE (`_overrides.scss`),
// `--surface-ground` FIELD WITH A 1PX `#ced4da` BORDER AND 4PX RADIUS, 0.5REM 0.75REM
// LABEL PADDING, A 2.357REM TRIGGER WITH A 14PX CHEVRON; OPTIONS 0.5REM 0.75REM.
export function PDropdown<V extends string | number>(props: {
  value: V | "";
  options: Array<{ label: string; value: V }>;
  onChange: (v: V) => void;
  placeholder?: string;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
}) {
  const { value, options, onChange, placeholder, disabled, ariaLabel, className } = props;
  return (
    <Select
      className={className}
      value={value}
      displayEmpty
      disabled={disabled}
      onChange={(e) => onChange(e.target.value as V)}
      inputProps={{ "aria-label": ariaLabel ?? placeholder }}
      IconComponent={(p) => (
        <span {...p} style={{ ...p.style, top: 0, right: 0, height: "100%", width: "2.357rem", transform: "none", display: "grid", placeItems: "center", color: "#6c757d", pointerEvents: "none" }}>
          <PrimeGlyph name="chevron-down" />
        </span>
      )}
      renderValue={(v) => {
        const found = options.find((o) => o.value === v);
        return found ? found.label : <span style={{ color: "#6c757d" }}>{placeholder}</span>;
      }}
      MenuProps={{ slotProps: { paper: { sx: { borderRadius: "4px", mt: 0.25, boxShadow: "0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12)" } } } }}
      sx={{
        width: "100%",
        fontSize: "1rem",
        borderRadius: "4px",
        // MUI SIZES `.MuiSelect-select.MuiInputBase-input` TO 1.4375EM; THE DOUBLED CLASS OUTRANKS
        // IT SO THE LABEL IS ONE 14PX METROPOLIS LINE AND THE FIELD 30PX, LIKE `p-dropdown`. MUI
        // DRAWS THE BORDER AS AN OVERLAY INSIDE THE BOX, SO THE PADDING CARRIES ITS 1PX
        "& .MuiSelect-select.MuiSelect-select": {
          height: "auto",
          minHeight: 0,
          padding: "calc(0.5rem + 1px) calc(0.75rem + 1px)",
          paddingRight: "2.357rem !important",
          lineHeight: "normal",
        },
      }}
    >
      {options.map((o) => (
        <MenuItem key={o.value} value={o.value} sx={{ fontSize: "1rem", padding: "0.5rem 0.75rem", minHeight: "auto" }}>
          {o.label}
        </MenuItem>
      ))}
    </Select>
  );
}
